import axios from "axios";

const baseURL = process.env.NEXT_PUBLIC_NEXTAUTH_URL || "http://localhost:3000";

export const setCookie = async (
  token: string,
  userId: string,
  expiredAt: string,
  roleId?: string,
) => {
  const isServer = typeof window === "undefined";

  if (isServer) {
    return axios.post(`${baseURL}/api/jwt`, {
      token,
      userId,
      expiredAt,
      roleId,
    });
  } else {
    return axios.post("/api/jwt", { token, userId, expiredAt, roleId });
  }
};

export const getCookie = async () => {
  const isServer = typeof window === "undefined";

  try {
    if (isServer) {
      return axios.get(`${baseURL}/api/jwt`, {
        withCredentials: true,
      });
    } else {
      return axios.get("/api/jwt", {
        withCredentials: true,
      });
    }
  } catch (error) {
    console.error("Error getting cookie:", error);
    return null;
  }
};

export const removeCookie = async () => {
  const isServer = typeof window === "undefined";

  if (isServer) {
    return axios.delete(`${baseURL}/api/jwt`);
  } else {
    return axios.delete("/api/jwt");
  }
};
